import React from 'react';
import Collection3 from '../../../components/collection/Collection3';
import HeroCollections from '../../../components/hero/HeroCollections';
import useDocumentTitle from '../../../components/useDocumentTitle';

const Collections = () => {
  useDocumentTitle(' Collections');

  return (
    <div>
      <HeroCollections />
      <div className="section mt-100">
        <div className="container">
          <Collection3 length={9} />
        </div>
      </div>
    </div>
  );
};

export default Collections;
